
import auth from '@/store/modules/auth.js';
import products from '@/store/modules/products.js';
import posts from '@/store/modules/posts.js';
import customers from '@/store/modules/customers.js';
import parties from '@/store/modules/parties.js'
import score from '@/store/modules/score.js'
import kickback from '@/store/modules/kickback.js'
import campaigns from '@/store/modules/campaigns.js'
import system from '@/store/modules/system.js'
import team from '@/store/modules/team.js'
import returns from '@/store/modules/returns.js'
import profile from '@/store/modules/profile.js'
import dealer from '@/store/modules/dealer.js';
import notifications from '@/store/modules/notifications.js'
import backorders from '@/store/modules/backorders.js'
import { createStore } from "vuex";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    products,
    posts,
    parties,
    customers,
    score,
    kickback,
    campaigns,
    system,
    returns,
    team,
    profile,
    dealer,
    notifications,
    backorders
  }
});
